import ScalarSidebarItems_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarItems.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                       */
//#region src/components/ScalarSidebar/ScalarSidebarItems.vue
var ScalarSidebarItems_default = ScalarSidebarItems_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarItems_default as default };

//# sourceMappingURL=ScalarSidebarItems.vue.js.map